import { State } from 'app/gamma/src/modules';
import { TeamType } from 'app/gamma/src/modules/state/models/teams';

export const getActiveOverlay = (state: State): string | null => {
  const { overlayType } = state.ui.overlay;
  return overlayType;
};

export const getTeamType = (state: State): TeamType | null => {
  const { teamType } = state.ui.overlay;
  return teamType;
};
